// List to Marketplace.  Transfer BNS NFT to escrow contract principal.

// For MVP:
//  - Call contract without parameters
//  - But need NFT post-condition
//  - Don't need to pass the receiver because it was hardcoded in the test contract

import { useConnect } from '@stacks/connect-react';
import { useState } from 'react';
import { StacksMainnet } from '@stacks/network';
import {} from '@stacks/bns';
import {
  AnchorMode,
  PostConditionMode,
  bufferCVFromString,
  NonFungibleConditionCode,
  makeStandardNonFungiblePostCondition,
  createAssetInfo,
  tupleCV,
} from '@stacks/transactions';
import { userSession } from './ConnectWallet';

import ContractCallBnsResolvePrincipal, {
  BnsContext,
} from './ContractCallBnsResolvePrincipal';

const ListToMarketplace = () => {
  const { doContractCall } = useConnect();

  // state for Resolve Principal context
  const [bnsNameContext, setBnsNameContext] = useState();
  const [bnsNamespaceContext, setBnsNamespaceContext] = useState();

  function transferBnsNameToContractPrincipal() {
    // To Do : before proceeding, check valid stxAddress, bns name and namespace. then display UI error message.

    const bnsContractAddress = 'SP000000000000000000002Q6VF78';
    const bnsContractName = 'bns';
    const bnsNftName = 'names'; //BNS NFT name
    const bnsOwner = userSession.loadUserData().profile.stxAddress.mainnet; //current owner of BNS. also tx-sender.
    const bnsTransferPostConditionCode = NonFungibleConditionCode.DoesNotOwn; //DoesNotOwn = owner sent NFT (BNS)
    const bnsAssetInfo = createAssetInfo(
      bnsContractAddress,
      bnsContractName,
      bnsNftName
    );

    const bnsAssetInfoTokenID = tupleCV({
      namespace: bufferCVFromString(bnsNamespaceContext),
      name: bufferCVFromString(bnsNameContext),
    });

    const bnsTransferPostCondition = makeStandardNonFungiblePostCondition(
      bnsOwner,
      bnsTransferPostConditionCode,
      bnsAssetInfo,
      bnsAssetInfoTokenID
    );

    doContractCall({
      network: new StacksMainnet(),
      anchorMode: AnchorMode.Any,
      contractAddress: 'SP33D1W6D1Q2ESQ72BM64D356TC5SFZESR5TGPJ9F', // marketplace contract address,
      contractName: 'bns-marketplace-v02', // marketplace contract name,
      functionName: 'transfer-name-to-contract', //bnsFunctionNameTransfer,

      functionArgs: [
        bufferCVFromString(bnsNamespaceContext),
        bufferCVFromString(bnsNameContext),
      ],

      postConditionMode: PostConditionMode.Deny,
      postConditions: [bnsTransferPostCondition],

      onFinish: (data) => {
        window //opens a new window, show transaction in Stacks Explorer
          .open(
            `https://explorer.stacks.co/txid/${data.txId}?chain=mainnet`,
            '_blank'
          )
          .focus();
        // need to do more fancy stuff here, like a pending txn spinning wheel
      },
      onCancel: () => {
        console.log('onCancel:', 'Transaction was canceled');
      },
    });
  }

  if (!userSession.isUserSignedIn()) {
    return; // return an empty component if user has not signed-in yet.
  }

  return (
    <div>
      <p>-o-</p>
      <BnsContext.Provider
        value={{
          bnsNameContext,
          setBnsNameContext,
          bnsNamespaceContext,
          setBnsNamespaceContext,
        }}
      >
        <ContractCallBnsResolvePrincipal />
        <p>
          Sell your BNS name : {bnsNameContext}.{bnsNamespaceContext}
        </p>
      </BnsContext.Provider>

      <p>
        <button
          className="Connect"
          onClick={() => transferBnsNameToContractPrincipal()}
        >
          List to BNS Marketplace
        </button>
      </p>
    </div>
  );
};

export default ListToMarketplace;
